import Api from '@/services/Api'

export default {
    leaLideres(){
        return Api().get('leaLideres')
    },
    leaLiderUsuarios(id_lider){
        return Api().get('leaLiderUsuarios/'+id_lider)
    },
    leaLider(id_usuario){
        return Api().get('leaLider/'+id_usuario)
    },
    leaUsuarios(id_lider){
        return Api().get('leaUsuarios/'+id_lider)
    },
    asigneLiderUsuarios(forma){
        return Api().post('asigneLiderUsuarios',forma)
    },
    elimineLiderUsuario(forma){
        return Api().post('elimineLiderUsuario',forma)
    }
}
